import {Nav, Button} from "react-bootstrap";
import React from "react";
import {QuantityButtons} from "./buttons/QuantityButtons";
import {connect} from "react-redux";
import {
    selectService,
    addWorker,
    addPackingWorker,
    addSetWorker,
    addTechnicalWorker,
    addExpensive, getPrice
} from "../actions/actionCreators";
import { withRouter } from 'react-router-dom';

const mapStateToProps = state => ({ ...state.order });
const mapDispatchToProps = dispatch => ({
    selectService,
    addWorker,
    addPackingWorker,
    addSetWorker,
    addTechnicalWorker,
    addExpensive,
});


class NavItemOrder extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            format: this.props.match.url.replace(/\/+$/g, '') === '/services/workers' ? '.svg' : '.png'
        };
    }

    eventKey = () => {
        switch (this.props.eventKey) {
            case'nissan':
                return 1;
            case 'truck':
                return 2;
            case 'pickup':
                return 3;
            // case 'worker':
            //     return 5;
            default:
                return 0;
        }
    };

    chooseService = () => {

        switch (this.props.eventKey) {
            case'nissan':
                return this.props.selectService(1);
            case 'truck':
                return this.props.selectService(2);
            case 'pickup':
                return this.props.selectService(3);
            case 'worker':
                // if (!this.props.quantity){
                //     this.props.selectService(5);
                //     if (this.props.order.barbar_worker === 0){
                //         this.props.addWorker();
                //     }
                // }
                // else{
                    return this.props.addWorker();
                // }

            case 'tech_service':
                return this.props.addTechnicalWorker();
            case 'layout_service':
                return this.props.addSetWorker();
            case 'packing_service':
                return this.props.addPackingWorker();
            case 'refrigrator':
                return this.props.addExpensive(1);
            case 'dresser':
                return this.props.addExpensive(5);
            case 'table':
                return this.props.addExpensive(10);
            case 'piano':
                return this.props.addExpensive(4);
            case 'treadmill':
                return this.props.addExpensive(6);
            case 'safe':
                return this.props.addExpensive(8);
            case 'heavy_safe':
                return this.props.addExpensive(11);

            default:
                return 0;
        }

    };

    tooltip = ()=> {
        switch (this.props.eventKey) {
            case 'nissan':
                return  'هزینه پس از انتخاب مبدا و مقصد مشخص می‌گردد.';
            case 'truck':
                return  'هزینه پس از انتخاب مبدا و مقصد مشخص می‌گردد.';
            case 'pickup':
                return  'هزینه پس از انتخاب مبدا و مقصد مشخص می‌گردد.';
            case 'worker':
                return  '۷۵،۰۰۰ تومان برای سه ساعت';
            case 'tech_service':
                return  'انجام امور فنی در مبدا و مقصد (باز و بستن لوستر، ماشین لباس‌شویی، تخت‌خواب و...)';
            case 'packing_service':
                return  'کارگر خانم و آقا جهت بسته بندی وسایل شما قبل از اسباب کشی';
            case 'refrigrator':
                return "در صورتی که عرض یخچال از ۷۰ سانت به بالا و یا وزن ۱۸ فوت به بالا باشد";
            case 'dresser':
                return "هر گونه ویترین و آینه کنسول و هرگونه کمد و کتابخانه که عرض آن از ۸۰ سانتیمتر به بالا و یا وزن آن ۵۰ کیلوگرم به بالا باشد";
            case 'table':
                return "در صورتی که میز غذاخوری ۶ نفره دارای شیشه باشد نیز حساب می‌گردد و هرگونهمیز کنفرانس هم شامل این دسته ‌می‌باشد"
            case 'piano':
                return "حمل پیانو رویال در تعهدات نوبار نمی‌باشد";
            case 'treadmill':
                return "هرگونه دستگاه ورزشی مثل دوجرخه، الپتیکال و...";
            case 'safe':
                return "گاو صندوقی که ارتفاع آن ۵۰ سانتیمتر باش";
            case 'heavy_safe':
                return "گاوصندوقی که ارتفاع آن بیشتر از ۵۰ سانتیمتر باشد";
            default:
                return '';
        }
    };

    render() {

        return (
            <>
            <Nav.Link as={'div'} title={this.tooltip()}
                      onClick={this.chooseService}
                      active={this.props.unique ? this.props.active : false}

                      className='circle' eventKey={this.props.eventKey}>
                <img src={`${process.env.PUBLIC_URL}/orders/images/${this.props.eventKey+this.state.format}`} alt={this.props.name} />
                <div className='info'>{this.props.name}</div>
            </Nav.Link>
            {this.props.quantity === "quantity" && <QuantityButtons eventKey={this.props.eventKey}/>}
            {this.props.quantity === 'shop' && 
            <a style={{textDecoration:"none"}} href="https://shop.nobaar.com" id='shop-services' rel="noreferrer noopener" target="_blank">
                <Button className="quantity shop">مشاهده فروشگاه</Button>
            </a>}
            </>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavItemOrder));
